import React from 'react'

import {
  Accordion as MUIAccordion,
  AccordionSummary,
  Typography,
  AccordionDetails,
} from '@material-ui/core'

import { MdExpandMore } from 'react-icons/md'
import useStyles from './styles'

const Accordion = ({ content, title }) => {
  const { root, heading } = useStyles()
  return (
    <MUIAccordion classes={{ root }}>
      <AccordionSummary
        expandIcon={<MdExpandMore color="white" />}
        aria-controls="panel1a-content"
      >
        <Typography className={heading}>{title}</Typography>
      </AccordionSummary>
      <AccordionDetails>{content}</AccordionDetails>
    </MUIAccordion>
  )
}

export default Accordion
